import { Download, FileText } from "lucide-react";
import { formatBytes } from "@/lib/api";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function DocumentPreview({ doc }) {
  const isImage = doc.content_type?.startsWith("image/");
  const isPdf = doc.content_type === "application/pdf";
  const url = `${API_URL}/api/documents/${doc.id}/download`;
  return (
    <div className="bg-cream-light rounded-lg border border-navy/5 overflow-hidden" data-testid={`document-preview-${doc.id}`}>
      {isImage && (
        <div className="bg-navy/5">
          <img src={url} alt={doc.original_filename} className="w-full max-h-[300px] object-contain"
            crossOrigin="use-credentials" onError={(e) => { e.target.style.display = "none"; }} data-testid="document-image-preview" />
        </div>
      )}
      {isPdf && (
        <div className="bg-navy/5">
          <img src={`${API_URL}/api/documents/${doc.id}/preview`} alt={`${doc.original_filename} page 1`} crossOrigin="use-credentials"
            className="w-full max-h-[420px] object-contain bg-white" data-testid="document-pdf-preview" />
          <p className="text-center text-[11px] text-navy/40 pt-1">Page 1 shown</p>
          <a href={url} target="_blank" rel="noopener noreferrer" className="block text-center text-xs text-gold py-3 min-h-[44px]" data-testid="open-pdf-full-btn">
            Open full PDF (all pages)
          </a>
        </div>
      )}
      <div className="p-3 flex items-center gap-3">
        <FileText className="w-5 h-5 text-navy/40 shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm text-navy font-medium truncate">{doc.original_filename}</p>
          <p className="text-xs text-navy/40">{doc.content_type} {doc.size ? `\u2022 ${formatBytes(doc.size)}` : ""}</p>
        </div>
        <a href={`${url}?download=1`} download={doc.original_filename}
          className="min-w-[44px] min-h-[44px] flex items-center justify-center rounded-lg bg-gold/10 text-gold hover:bg-gold/20 transition-colors"
          data-testid="download-document-btn" aria-label="Download document">
          <Download className="w-5 h-5" />
        </a>
      </div>
    </div>
  );
}
